import {Component} from '@angular/core';

@Component({
  selector: 'app-socials',
  templateUrl: './socials.component.html',
  styleUrls: ['./socials.component.sass']
})
export class SocialsComponent {
  activeSocial: any;
  socials = [
    {
      icon: 'whatsapp_color.svg',
      link: 'https://api.whatsapp.com/send/?phone=77080000160&text&type=phone_number&app_absent=0'
    },
    {
      icon: 'facebook.svg',
      link: 'https://www.facebook.com/telecomkz.business',
    },
    {
      icon: 'insta.svg',
      link: 'https://www.instagram.com/kazakhtelecom_business',
    },
    {
      icon: 'youtube.svg',
      link: 'https://www.youtube.com/@KazakhtelecomBusiness',
    },
    {
      icon: 'tiktok.svg',
      link: 'https://www.tiktok.com/@kazakhtelecom_business',
    }
  ]
}
